import { Component, OnInit, ChangeDetectionStrategy, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { PDialogFooterBtnActionType } from '../p-dialog-footer-btn-config.interface';
import { ButtonTypeEnum } from '@panaya/ui/p-button';

@Component({
    selector: 'pui-p-info-dialog',
    template: `
        <p-dialog-container>
            <div class="priority-container">
                <p-dialog-header
                    class="priority-header"
                    iconName="{{ showIcon ? 'info' : '' }}"
                    title="{{ headerText }}"
                    [isSentenceCase]="isHeaderSentenceCase"
                ></p-dialog-header>
                <p-button
                    class="learnMoreBtn"
                    *ngIf="!!learnMoreBtnUrl"
                    label="{{ learnMoreBtnText }}"
                    [buttonType]="buttonType.Tertiary"
                    (buttonClicked)="openLink()"
                ></p-button>
            </div>
            <ng-container *ngIf="bodyText; else outletContent">
                <div class="p-dialog-content simple-dialog-body p-paragraph-1" [innerHTML]="bodyText" *ngIf="isHtmlContent"></div>
                <div class="p-dialog-content simple-dialog-body" *ngIf="!isHtmlContent">{{ bodyText }}</div>
            </ng-container>
            <ng-template #outletContent>
                <ng-container *ngTemplateOutlet="bodyTemplate || null; context: templateContext" #outletContent></ng-container>
            </ng-template>
            <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
        </p-dialog-container>
    `,
    styleUrls: ['./p-info-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PInfoDialogComponent implements OnInit {
    headerText!: string;
    bodyText?: string;
    bodyTemplate?: TemplateRef<HTMLElement>;
    closeBtn?: string;
    isHtmlContent? = false;
    templateContext?: any;
    isHeaderSentenceCase? = true;
    learnMoreBtnText?: string;
    learnMoreBtnUrl?: string;
    showIcon? = true;
    buttonType = ButtonTypeEnum;
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: PInfoDialogData,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.headerText = this.data.headerText;
        this.bodyText = this.data.bodyText;
        this.isHtmlContent = this.data.isHtmlContent;
        this.closeBtn = this.data.closeBtn ? this.data.closeBtn : 'Actions.close';
        this.bodyTemplate = this.data.bodyTemplate;
        this.templateContext = this.data.templateContext ?? null;
        this.isHeaderSentenceCase = this.data.isHeaderSentenceCase !== undefined ? this.data.isHeaderSentenceCase : true;
        this.learnMoreBtnText = this.data.learnMoreBtnText;
        this.learnMoreBtnUrl = this.data.learnMoreBtnUrl;
        this.showIcon = this.data.showIcon;
    }

    openLink() {
        window.open(this.learnMoreBtnUrl, '_blank');
    }

    get footerConfig() {
        return [
            {
                type: PDialogFooterBtnActionType.Close,
                text: this.closeBtn
            }
        ];
    }
}

export interface PInfoDialogData {
    headerText: string;
    bodyText?: string;
    closeBtn?: string;
    learnMoreBtnText?: string;
    learnMoreBtnUrl?: string;
    isHtmlContent?: boolean;
    bodyTemplate?: TemplateRef<any>;
    templateContext?: any;
    isHeaderSentenceCase?: boolean;
    showIcon?: boolean;
}
